module.exports = __webpack_public_path__ + "static/img/jude-beck.10cd023f.jpg";